module.exports = __webpack_public_path__ + "img/colored-square.dbf927dd.svg";